<template>
    <div >
        <div class="module_container" style="margin-bottom:50px">
            <template v-if="orden != ''">
                <h2 class="title--m" style="font-family: Heebo; font-weight: normal">Orden Creada</h2>
                <div class="maxWidth">
                    <v-alert class="mt-3" dense type="warning" color="#9be51a" style="font-family: Heebo; font-weight: normal">
                        Se ha creado una orden a su nombre con la referencia "{{ orden }}"
                    </v-alert>
                </div>
            </template>
            <template v-if="resultadoFactura != ''">
                <div class="maxWidth">
                    <v-alert class="mt-3" dense type="warning" color="#9be51a" style="font-family: Heebo; font-weight: normal"> {{ resultadoFactura }} </v-alert>
                </div>
            </template>
        </div>
        <div class="module_container">
            <h2 style="font-family: Heebo; font-size: 22px; color: black; font-weight: normal ">¿Ya tienes una referencia y quieres consultar el estado de la reparación?</h2>
            <p class="mt-3 text--smaller">
                <router-link to="/" class="menu menu--link" style="font-family: Heebo; font-weight: normal">
                    Accede a la página de consultas
                    <v-icon color="#9be51a">mdi-chevron-right</v-icon>
                </router-link>
            </p>
            </br></br>

        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            orden() { return this.$bus.resultadosAPI.ordenCreada },
            resultadoFactura() { return this.$bus.resultadosAPI.subirFactura },
            resultadoExpedicion() { return this.$bus.resultadosAPI.generarExpedicion }
        }
    }
</script>

<style scoped>
    .v-alert__content {
        padding-left: 10px !important;
    }
</style>
